import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {UtilConfig} from 'app/autenticacion/servicios/UtilConfig';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {WebServices} from 'app/layout/recursos/modelo/consumerModel/web-services.enum';
import {ResponseWebService} from 'app/layout/recursos/modelo/consumerModel/responseWebService';
import {ErrorMapping} from 'app/layout/recursos/modelo/consumerModel/error-mapping.enum';
import {ConsumerException} from 'app/layout/recursos/modelo/consumerModel/consumerException';


@Injectable()
export class ConsumerService {

    constructor(private jwtUtil: UtilConfig, private http: Http) {

    }

    search<T>(term: string, estado: string, urlWebService: WebServices, headers: Headers = this.generateHeaders()): Observable<ResponseWebService<T>> {
        const params = {
            'criterio': term ? term : '',
            'estado': (estado === 'TODOS') ? null : estado
        };
        return this.post<T>(urlWebService, params, headers);
    }

    getById<T>(origenCRUD: string, id: number, urlWebService: WebServices, headers: Headers = this.generateHeaders()): Observable<ResponseWebService<T>> {
        return this.post<T>(urlWebService, {[origenCRUD]: {id: id}}, headers);
    }


    activar<T>(urlWebService: WebServices, params: any = {}, headers: Headers = this.generateHeaders()): Observable<ResponseWebService<T>> {
        return this.update<T>(urlWebService, params, headers);
    }

    desactivar<T>(origenCRUD: string, item: T, urlWebService: WebServices, headers: Headers = this.generateHeaders()): Observable<ResponseWebService<T>> {
        return this.delete<T>(urlWebService, {[origenCRUD.toLowerCase()]: item}, headers);
    }

    //PUT - CREATE
    create<T>(urlWebService: WebServices, params: any = {}, headers: Headers = this.generateHeaders()): Observable<ResponseWebService<T>> {
        const url = `${this.jwtUtil.URL_WS_BACKEND}${urlWebService}`;
        return this.mapObservable<T>(this.http.post(url, params, {headers: this.generateHeaders()}));
    }

    //GET - READ
    get<T>(urlWebService: string): Observable<ResponseWebService<T>> {
        const url = `${this.jwtUtil.URL_WS_BACKEND}${urlWebService}`;
        return this.mapObservable<T>(this.http.get(url, {headers: this.generateHeaders()}));
    }

    //GET - READ
    post<T>(urlWebService: WebServices, params: any = {}, headers: Headers = this.generateHeaders()): Observable<ResponseWebService<T>> {
        const url = `${this.jwtUtil.URL_WS_BACKEND}${urlWebService}`;
        return this.mapObservable<T>(this.http.post(url, params, {headers: this.generateHeaders()}));
    }


    //GET - READ
    getAuto_jwt<T>(urlWebService: WebServices, params: any = {}, headers: Headers = this.generateHeaders()): Observable<ResponseWebService<T>> {
        const url = `${this.jwtUtil.URL_WS_BACKEND}${urlWebService}`;
        return this.mapObservableSin_jwt<T>(this.http.post(url, params, {headers: this.generateHeaders()}));
    }

    //GET - READ SIN JWT
    getSinJWT<T>(urlWebService: WebServices, params: any = {}, headers: Headers = this.generateHeadersSinJWT()): Observable<ResponseWebService<T>> {
        const url = `${this.jwtUtil.URL_WS_BACKEND}${urlWebService}`;
        return this.mapObservableSin_jwt<T>(this.http.post(url, params, {headers: this.generateHeadersSinJWT()}));
    }

    actualizar<T>(origenCRUD: string, item: T, urlWebService: WebServices, headers: Headers = this.generateHeaders()): Observable<ResponseWebService<T>> {
        return this.update<T>(urlWebService, {[origenCRUD.toLowerCase()]: item}, headers);
    }

    //POST - UPDATE
    update<T>(urlWebService: WebServices, params: any = {}, headers: Headers = this.generateHeaders()): Observable<ResponseWebService<T>> {
        const url = `${this.jwtUtil.URL_WS_BACKEND}${urlWebService}`;
        return this.mapObservable<T>(this.http.post(url, params, {headers: this.generateHeaders()}));
    }

    //POST - UPDATE
    updateNroBanco<T>(urlWebService: string): Observable<ResponseWebService<T>> {
        const url = `${this.jwtUtil.URL_WS_BACKEND}${urlWebService}`;
        return this.mapObservable<T>(this.http.post(url, {}, {headers: this.generateHeaders()}));
    }

    //POST - UPDATE
    getParam<T>(urlWebService: WebServices, param: any = '', headers: Headers = this.generateHeaders()): Observable<ResponseWebService<T>> {
        const url = `${this.jwtUtil.URL_WS_BACKEND}${urlWebService}`;
        return this.mapObservable<T>(this.http.get(url + '/' + param, {headers: this.generateHeadersSinJWT()}));
    }

    //DELETE
    delete<T>(urlWebService: WebServices, params: any = {}, headers: Headers = this.generateHeaders()): Observable<ResponseWebService<T>> {
        const url = `${this.jwtUtil.URL_WS_BACKEND}${urlWebService}`;
        return this.mapObservable<T>(this.http.post(url, params, {headers: this.generateHeaders()}));
    }

    private generateHeaders(): Headers {
        const headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        return headers;
    }

    private generateHeadersSinJWT(): Headers {
        const headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        return headers;
    }

    private mapObservable<T>(observable: Observable<any>): Observable<ResponseWebService<T>> {
        return observable
            .map((res) => res.json())
            .map((res: ResponseWebService<T>) => {
                //this.jwtUtil.setJwtToken(res.token);
                if (res.codigo != 0) return res;
                else throw new ConsumerException(ErrorMapping.CODE_SRV_0, res.mensaje, res.codigo);
            })
            .catch((error: any) => {
                let err: ConsumerException;
                if (error.error == ErrorMapping.CODE_SRV_0) {
                    err = error;
                } else if (ErrorMapping['CODE_' + error.status]) {
                    err = new ConsumerException(ErrorMapping['CODE_' + error.status], error.json().message, error.status).json();
                } else {
                    err = new ConsumerException(ErrorMapping['CODE'], 'se presentó un error, contacte al administrador para obtener mas información', -1).json();
                }
                if ((!err.message || err.message == 'No message available') && err.error) err.message = err.error;
                console.error('Error consumiendo servicios -> error: ', err, error);
                return Observable.throw(err || new ConsumerException('Server error', 'Error en el servidor', 0));
            });
    }

    private mapObservableSin_jwt<T>(observable: Observable<any>): Observable<ResponseWebService<T>> {
        return observable
            .map((res) => res.json())
            .map((res: ResponseWebService<T>) => {
                if (res.codigo != 0) return res;
                else throw new ConsumerException(ErrorMapping.CODE_SRV_0, res.mensaje, res.codigo);
            })
            .catch((error: any) => {
                let err: ConsumerException;
                if (error.error == ErrorMapping.CODE_SRV_0) {
                    err = error;
                } else if (ErrorMapping['CODE_' + error.status]) {
                    err = new ConsumerException(ErrorMapping['CODE_' + error.status], error.json().message, error.status).json();
                } else {
                    err = new ConsumerException(ErrorMapping['CODE'], 'se presentó un error, contacte al administrador para obtener mas información', -1).json();
                }
                if ((!err.message || err.message == 'No message available') && err.error) err.message = err.error;
                console.error('Error consumiendo servicios -> error: ', err, error);
                return Observable.throw(err || new ConsumerException('Server error', 'Error en el servidor', 0));
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/recursos/servicio/consumer.service.ts